<template>
  <v-dialog
    v-model="dialog"
    :fullscreen="isMobile()"
    max-width="700"
    scrollable
  >
    <v-card
      tile
      style="
        padding-bottom: env(safe-area-inset-bottom);
        padding-top: env(safe-area-inset-top);
      "
    >
      <toolbar-card-visita
        :opcao_checklist="
          configuracoes.dados.opcoes_checklist.find(
            (oc) => oc.rota == '/rebanho'
          )
        "
      />
      <v-card-text>
        <v-row :dense="isMobile()" class="mt-6">
          <v-col md="6" cols="12">
            <v-text-field
              label="Nº de vacas em ordenha"
              class="font-weight-medium title"
              inputmode="numeric"
              pattern="[0-9]*"
              v-mask="'#####'"
              v-model="visita.nro_vacas_ordenha"
              outlined
              :dense="isMobile()"
              clearable
            ></v-text-field>
          </v-col>
          <v-col md="6" cols="12">
            <v-text-field
              label="Qtde de ordenhas"
              class="font-weight-medium title"
              inputmode="numeric"
              pattern="[0-9]*"
              v-mask="'#####'"
              v-model="visita.qtd_ordenhas"
              outlined
              suffix="/dia"
              :dense="isMobile()"
              clearable
            ></v-text-field>
          </v-col>
          <v-col md="6" cols="12">
            <v-text-field
              label="Nº de vacas secas"
              class="font-weight-medium title"
              inputmode="numeric"
              pattern="[0-9]*"
              v-mask="'#####'"
              v-model="visita.nro_vacas_secas"
              outlined
              :dense="isMobile()"
              clearable
            ></v-text-field>
          </v-col>
          <v-col md="6" cols="12">
            <v-text-field
              label="Nº de novilhas"
              class="font-weight-medium title"
              inputmode="numeric"
              pattern="[0-9]*"
              v-mask="'#####'"
              v-model="visita.nro_novilhas"
              outlined
              :dense="isMobile()"
              clearable
            ></v-text-field>
          </v-col>
          <v-col md="6" cols="12">
            <v-text-field
              label="Nº de bezerras"
              class="font-weight-medium title"
              inputmode="numeric"
              pattern="[0-9]*"
              v-mask="'#####'"
              v-model="visita.nro_bezerras"
              outlined
              :dense="isMobile()"
              clearable
            ></v-text-field>
          </v-col>
          <v-col md="6" cols="12">
            <v-checkbox
              :class="{ 'mt-0': isMobile() }"
              class="justify-center"
              v-model="visita.pre_parto"
              label="Pré-Parto"
            ></v-checkbox>
          </v-col>
          <v-col cols="12">
            <v-textarea
              label="Observações"
              placeholder="Anote observações gerais do rebanho e do lote pré-parto"
              persistent-placeholder
              outlined
              v-model="visita.obs_pre_parto"
              auto-grow
            ></v-textarea>
          </v-col>
          <v-col cols="12">
            <btn-salvar-dados-visita />
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from "vuex";
import BtnSalvarDadosVisita from "./BtnSalvarDadosVisita.vue";
//import BtnSalvarDadosVisita from "./BtnSalvarDadosVisita.vue";
import ToolbarCardVisita from "./ToolbarCardVisita.vue";
export default {
  components: {
    ToolbarCardVisita,
    BtnSalvarDadosVisita /*BtnSalvarDadosVisita*/,
  },
  watch: {
    dialog: function (open) {
      if (!open) {
        this.$router.go(-1);
      }
    },
  },
  computed: mapState("visitaTecnica", ["configuracoes", "visita"]),
  data: () => ({
    dialog: false,
  }),
  methods: {
    isMobile() {
      return this.$mq == "sm";
    },
  },
  mounted() {
    this.dialog = true;
  },
};
</script>

<style>
/* valores bem visíveis; escala com --font-scale */
.metric-num .v-text-field__slot input {
  font-weight: 700;
  font-size: clamp(
    1.6rem,
    3.6vw + 0.4rem,
    2.2rem
  ); /* ~25–35px antes da escala */
  line-height: 1.3;
  text-align: right;
  font-variant-numeric: tabular-nums;
  letter-spacing: 0.01em;
}

/* label legível, sem roubar atenção do número */
.metric-num .v-label {
  font-size: 1rem;
  opacity: 0.9;
}

/* sufixos discretos (ex.: “/dia”) */
.metric-num .v-text-field__suffix {
  font-weight: 600;
  opacity: 0.75;
}
</style>